import React, { useState, useEffect } from "react";
import _CONFIG_ from "config/Constant";

import image1 from "assets/images/hot-games/Hot Games - 01.jpg";
import image2 from "assets/images/hot-games/Hot Games - 02.webp";
import image3 from "assets/images/hot-games/Hot Games - 03.webp";

import hoverImage1 from "assets/images/hot-games/Hot Games - 1.jpg";
import hoverImage2 from "assets/images/hot-games/Hot Games - 2.jpg";
import hoverImage3 from "assets/images/hot-games/Hot Games - 3.jpg";

const HotGames = () => {
  const hotGames = [
    {
      title: "Slots",
      desc: "Heng Ong Bet Slot offers exciting gameplay with rich rewards, featuring vibrant graphics and bonus features!",
      image: image1,
      hoverImage: hoverImage1,
    },
    {
      title: "Lottery",
      desc: "Experience the thrill of live lottery games with exciting prizes at Heng Ong Bet.",
      image: image2,
      hoverImage: hoverImage2,
    },
    {
      title: "Live Casino",
      desc: "Heng Ong Bet Casino delivers vibrant slots, big jackpots, and an immersive, user-friendly gaming environment!",
      image: image3,
      hoverImage: hoverImage3,
    },
  ];

  return (
    <div className="flex g-30">
      {hotGames.map((game, i) => {
        return (
          <>
            <a
              href={_CONFIG_.REGISER_URL}
              rel="noindex nofollow"
              className="hot-game-item"
            >
              <img
                src={game.image}
                alt={game.alt ?? `Slide ${i}`}
                key={i}
                style={{ width: "198px", height: "148px", borderRadius: "8px" }}
                loading={i > 0 ? "lazy" : "eager"}
              />
              <div className="image-overlay">
                <p className="image-title">{game.title}</p>
                <p className="image-desc">{game.desc}</p>
              </div>
              <div className="image-hover-overlay">
                <img
                  src={game.hoverImage}
                  alt={game.alt ?? `Slide ${i}`}
                  key={i}
                  style={{
                    width: "198px",
                    height: "148px",
                    borderRadius: "8px",
                  }}
                  loading={"lazy"}
                />
              </div>
            </a>
          </>
        );
      })}
    </div>
  );
};

export default HotGames;
